
window.payment = {
    paymentList: [],
    payHandler: null,
    paymentIntent: null,
    authorisedPaymentIntent: null,
    phonePaymentButton: null,
    events: {
        phonePaymentModalComplete: 'phone-payment-modal-complete'
    },
    providers: {
        apple: {
            active: true,
            supported: false,
        },
        google: {
            active: true,
            supported: true,
        },
    },

    isExpiredCard: function(expiryDate) {
        // the expiryDate should be a string formatted dd/mm
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const currentMonth = currentDate.getMonth() + 1

        const [inputMonth, inputYear] = expiryDate.trim().split('/').map(Number)
        const fullInputYear = inputYear + 2000

        if (fullInputYear < currentYear || (fullInputYear === currentYear && inputMonth < currentMonth)) {
            return true
        }

        return inputMonth < 1 || inputMonth > 12;
    },

    getStoredPaymentCards: async function() {
        try {
            // reset the list
            this.paymentList = [];

            const response = await window.utils.request.get('/wp-json/klira/payment-method/get-list-payment');

            if (!response) {
                return
            }

            this.paymentList = response
        } catch (error) {
            console.error('PAYMENTS: getStoredPaymentCards ERROR: ', error);
        }
    },

    renderCardLogo: function(brand) {
        switch (brand?.toLowerCase()) {
            case 'visa':
                return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/visa-card.svg'
            case 'mastercard':
                return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/master-card.svg'
            case 'amex':
            case 'american_express':
                return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/amex-card.svg'
            case 'discover':
                return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/dis-card.svg'
            case 'jcb':
                return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/jcb-card.svg'
            default:
                return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/icn-card.svg'
        }
    },

    initialisePhonePaymentProviders: async function() {
        const cbInstance = window.Chargebee
            ? window.Chargebee.getInstance()
            : null;

        if (!cbInstance) {
            console.error('Could not get Chargebee instance, cannot pay with phone payment provider');
            return;
        }


        await cbInstance.load("apple-pay")
            .then((payHandler) => {
                if (payHandler.supportsApplePay()) {
                    console.log('PAYMENTS: apple pay is supported');
                    this.providers.apple.supported = true;
                    console.log('PAYMENTS: deactivating google pay');
                    this.providers.google.active = false;

                    if (this.providers.apple.active) {
                        // don't assign the handler if apple pay is inactive
                        this.payHandler = payHandler;
                    }
                }
            })

        if (this.providers.google.active) {
            return cbInstance.load("google-pay").then((payHandler) => {
                console.log('PAYMENTS: google pay is supported');
                this.payHandler = payHandler;
            });
        }
    },
    clearPaymentIntent: function() {
        console.log('PAYMENTS: Clearing payment intent');
        this.paymentIntent = null;
        this.authorisedPaymentIntent = null;
        this.removePhonePaymentButton();
    },
    createPaymentIntent: async function(amount) {
        try {
            let method = this.supportsApplePay() ? 'apple_pay' : 'google_pay';

            console.log('PAYMENTS: createPaymentIntent for', amount, 'with', method);

            let data = {
                amount: Number(amount) * 100,
                code: 'GBP',
                method
            };

            if (window.customer.customer_id) {
                // we have a customer ID, use it
                data.customer_id = window.customer.customer_id
            }

            const response = await window.utils.request.post(
                '/wp-json/klira/checkout/payment-intent',
                data
            );

            let responseJson = typeof response === 'object' ? response : JSON.parse(response);

            console.log('PAYMENTS: createPaymentIntent response', responseJson);

            if (!responseJson.success) {
                console.error('PAYMENTS: createPaymentIntent failed: ', responseJson.message);
                return;
            }

            this.paymentIntent = responseJson.intent;

            if (this.paymentIntent.customer_id) {
                // the customer ID is only present when it is a request made without sending one.
                // add it to the customer object so that we can use it in subsequent requests
                window.customer.customer_id = this.paymentIntent.customer_id;
            }

            console.log('PAYMENTS: setting payment intent on handler');
            return this.payHandler.setPaymentIntent(this.paymentIntent);
        } catch (error) {
            console.error('PAYMENTS: createPaymentIntent ERROR: ', error);
        }
    },
    setAuthorisedPaymentIntent: function(paymentIntent) {
        let currentTimestamp = Date.now() / 1000;

        if (paymentIntent.status === 'authorized' && paymentIntent.expires_at && paymentIntent.expires_at > currentTimestamp) {
            console.log('PAYMENTS: received authorised payment intent', paymentIntent);
            this.authorisedPaymentIntent = paymentIntent;
            return true;
        }

        console.error('PAYMENTS: received payment intent that failed validation', paymentIntent);
        this.authorisedPaymentIntent = null;

        return false;
    },
    removePhonePaymentButton: function() {
        if (!this.phonePaymentButton) {
            return;
        }

        console.log('PAYMENTS: Removing existing phone payment button');
        this.phonePaymentButton.remove();
        this.phonePaymentButton = null;
    },
    addPhonePaymentButton: async function(buttonContainerSelector) {
        console.log('PAYMENTS: Setting payment button in container', buttonContainerSelector);

        this.removePhonePaymentButton();

        const buttonWrapper = document.createElement('div');
        buttonWrapper.id = 'phone-payment-button-wrapper';
        document.querySelector(`${buttonContainerSelector}`).appendChild(buttonWrapper)

        const buttonWrapperSelector = `#${buttonWrapper.id}`;

        return this.payHandler.mountPaymentButton(buttonWrapperSelector)
            .then((button) => {
                console.log('PAYMENTS: Created payment button');
                this.phonePaymentButton = document.querySelector(`${buttonWrapperSelector}`);
            })
            .then(() => {
                console.log('PAYMENTS: Configuring payment button');
                return this.payHandler.handlePayment();
            })
            .then((result) => {
                console.log('PAYMENTS: Handling payment result', result);

                if (!result) {
                    return;
                }

                let paymentIntent = result.paymentIntent;

                let authorised = this.setAuthorisedPaymentIntent(paymentIntent);

                if (authorised) {
                    this.authorisedPaymentIntent = paymentIntent;
                } else {
                    this.authorisedPaymentIntent = null;
                }

                console.log(`PAYMENTS: Firing event ${this.events.phonePaymentModalComplete}, authorised: `, authorised);
                const event = new CustomEvent(
                    this.events.phonePaymentModalComplete,
                    {
                        detail: {
                            authorised: authorised
                        }
                    }
                );
                document.dispatchEvent(event);

                // remove the button now that payment is configured
                this.removePhonePaymentButton();
            })
            .catch((error) => {
                console.error('PAYMENTS: There was an error', error);
                this.authorisedPaymentIntent = null;

                const event = new CustomEvent(
                    this.events.phonePaymentModalComplete,
                    {
                        detail: {
                            authorised: false,
                            error: error
                        }
                    }
                );
                document.dispatchEvent(event);
            });
    },

    hasPaymentIntent: function() {
        return this.paymentIntent != null
    },

    hasAuthorisedPaymentIntent: function() {
        return this.authorisedPaymentIntent != null
    },

    hasPhonePaymentButton: function() {
        return this.phonePaymentButton != null
    },

    supportsApplePay: function() {
        return (this.payHandler && typeof this.payHandler.supportsApplePay !== "undefined" && this.payHandler.supportsApplePay());
    },
    supportsGooglePay: function() {
        return (this.payHandler && (typeof this.payHandler.supportsApplePay === "undefined" || !this.payHandler.supportsApplePay()));
    },
};
